import React, { useEffect, useState, useRef } from 'react';
import * as R from 'ramda';
import * as Loadings from '../../../../constants/loadings/backoffice/partners';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';

import { CreateUserByPartnerId, UpdateUserByPartnerId } from '../../../../actions/backoffice/partners';

export const AddPartnerUser = ({ partnerId, selectedUser, etablissements, isLoading }) => {
	const dispatch = useDispatch();
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const formRef = useRef();

	const initValue = !R.isNil(selectedUser) ? { ...selectedUser } : {
		firstName: '',
		lastName: '',
		email: '',
		phoneNumber: '',
		countryCode: '33',
		phoneCountry: 'FR',
		isEnabled: undefined,
		partnerId: partnerId,
		etablissementId: undefined,
		daysOfTraining: 0,

	};
	if (!R.isNil(selectedUser)) {
		const phone = parsePhoneNumber(selectedUser.phoneNumber, selectedUser.countryCode);
		if (!R.isNil(phone)) {
			initValue.phoneNumber = phone.nationalNumber;
			initValue.countryCode = phone.countryCallingCode;
			initValue.phoneCountry = phone.country;
		}
	}

	const [userInfo, setUserInfo] = useState(initValue);
	const [showFormation, setShowFormation] = useState(R.isNil(userInfo) ? false : userInfo.daysOfTraining > 0);

	function resetForm() {
		formRef.current.classList.remove('was-validated');
		setUserInfo(initValue);
		setShowFormation(undefined);
	}

	useEffect(() => {
		if (R.isNil(selectedUser)) {
			resetForm();
		} else {
			const user = { ...selectedUser };
			const phone = parsePhoneNumber(selectedUser.phoneNumber, selectedUser.countryCode);
			if (!R.isNil(phone)) {
				user.phoneNumber = phone.nationalNumber;
				user.countryCode = phone.countryCallingCode;
				user.phoneCountry = phone.country;
			}

			setUserInfo(user);
			setShowFormation(selectedUser.daysOfTraining > 0);
		}

	}, [selectedUser]);

	useEffect(() => {
		if(showFormation === false){
			setUserInfo({ ...userInfo, daysOfTraining: 0 });
		}
	}, [showFormation])

	return (
		<div className="modal fade px-0" id="AddPartnerUser" aria-labelledby="AddPartnerUserLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-info rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h3 className="sr-only visually-hidden">Add partner user</h3>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-info text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="AddPartnerUserLabel">ajouter un nouvel utilisateur</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default pt-0">
						{/* <p className="h5 lh-copy mb-gutter o-60">Vous pouvez ajouter un nouvel utilisateur à ce partenaire. Remplissez les champs ci-dessous et ajoutez les données du nouvel utilisateur.</p> */}
						<form className="block" noValidate ref={formRef}>
							<div className="form-row">
								{/* <div className="form-group col col-lg-4">
									<label className="h6 font-weight-bolder" htmlFor="role">Intitulé du Poste</label>
									<select className="form-control custom-select" id="role" aria-label="Default select example">
										<option selected>Intitulé du Poste...</option>
										<option value="Admin">Employée</option>
										<option value="Admin">Commercial</option>
										<option value="Admin">Assistant</option>
										<option value="Admin">Admin</option>
									</select>
								</div> */}
								<div className="col">
									<div className="form-row">
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="Prenom">Prénom *</label>
											<input required type="text" className="form-control" id="Prenom" value={userInfo.firstName} onChange={(e) => setUserInfo({ ...userInfo, firstName: e.target.value })} />
										</div>
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="Nom">Nom *</label>
											<input required type="text" className="form-control" id="Nom" value={userInfo.lastName} onChange={(e) => setUserInfo({ ...userInfo, lastName: e.target.value })} />
										</div>
									</div>
									<div className="form-row">
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="Email">Email *</label>
											<input required type="email" className="form-control" id="Email" value={userInfo.email} onChange={(e) => setUserInfo({ ...userInfo, email: e.target.value })} />
										</div>
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="phoneNumberInput">Téléphone</label>
											<div className="input-group mb-0">
												<select className="custom-select rounded container-tiny mr-2" id={"phonecode"} tabIndex={-98} value={userInfo.countryCode} onChange={(event) => {
													let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
													setUserInfo({ ...userInfo, countryCode: event.target.value, phoneCountry: pc });
												}}>
													{
														countryTelData.allCountries.map((country, index) => {
															let dialCode = country.dialCode;
															return (
																<option key={index} value={dialCode}>{countries.getName(country.iso2, "fr", { select: "official" })} (+{dialCode})</option>
															);
														})
													}
												</select>
												<input type="tel" className="form-control rounded" id="phoneNumberInput" value={parsePhoneNumber(userInfo.phoneNumber, userInfo.phoneCountry) !== undefined ? parsePhoneNumber(userInfo.phoneNumber, userInfo.phoneCountry).formatNational() : userInfo.phoneNumber} aria-describedby="telephoneHelpBlock"
													onChange={(e) => {
														document.getElementById("phoneNumberInput").setCustomValidity("");
														setUserInfo({ ...userInfo, phoneNumber: e.target.value });
													}
													} />
											</div>
										</div>
									</div>
									<div className="form-row">
										<div className="form-group col">
											<label className="h6 font-weight-bolder" htmlFor="role">Identifier l'établissement</label>
											<select className="form-control custom-select" id="role" aria-label="Default select example" value={R.isNil(userInfo.etablissementId) ? "Partner" : userInfo.etablissementId} onChange={(e) => setUserInfo({ ...userInfo, etablissementId: e.target.value !== "Partner" ? e.target.value : undefined })}>
												<option value="Partner">Partenaire</option>
												{
													R.isNil(etablissements) ?
														''
														:
														etablissements.map((e) => {
															return (<option key={e.id} value={e.id}>{e.name}</option>);
														})
												}

											</select>
										</div>
									</div>
								</div>
							</div>
							{
								R.isNil(userInfo.etablissementId) ?
									''
									:
									<>
										<hr className="my-3" />
										<div className="grid grid-md-2 align-items-center my-sm">
											<div className="mr-auto my-auto">
												<h5 className={"h4 text-uppercase text-secondary font-weight-bolder my-auto"}>Onglet Paiement</h5>
												{/* <p className="o-60 fs-3 mb-0">Activer ou désactiver l'utilisateur de ce partenaire</p> */}
											</div>
											<div className="flex-row ml-auto align-items-center">
												{/* <div className="form-inline mb-3"> */}
												<div className="custom-control custom-radio custom-control-inline" >
													<input required={userInfo.isEtablissementAdmin === undefined ? true : false} type="radio" id='OuiPaiement' name='Paiement' onClick={() => setUserInfo({ ...userInfo, isEtablissementAdmin: true })} className="custom-control-input" checked={userInfo.isEtablissementAdmin === true} />
													<label className="custom-control-label" htmlFor='OuiPaiement'>Oui</label>
												</div>
												<div className="custom-control custom-radio custom-control-inline mr-0" >
													<input required={userInfo.isEtablissementAdmin === undefined ? true : false} type="radio" id='NonPaiement' name='Paiement' onClick={() => setUserInfo({ ...userInfo, isEtablissementAdmin: false })} className="custom-control-input" checked={userInfo.isEtablissementAdmin === false} />
													<label className="custom-control-label" htmlFor='NonPaiement'>Non</label>

												</div>
											</div>
										</div>
									</>
							}

							<hr className="my-3" />
							<div className="grid grid-md-2 align-items-center my-sm">
								<div className="mr-auto">
									<h5 className={"h4 text-uppercase text-secondary font-weight-bolder my-auto"}>Formation</h5>
								</div>
								<div className="flex-row ml-auto align-items-center">
									{/* <div className="form-inline mb-3"> */}
									<div className="custom-control custom-radio custom-control-inline" >
										<input required={showFormation === undefined ? true : false} type="radio" id={'OuiFormation'} name='Formation' onClick={() => setShowFormation(true)} onChange={() => { }} className="custom-control-input" checked={showFormation === true} />
										<label className="custom-control-label" htmlFor={'OuiFormation'}>Oui</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline mr-0" >
										<input required={showFormation === undefined ? true : false} type="radio" id={'NonFormation'} name='Formation' onClick={() => setShowFormation(false)} onChange={() => { }} className="custom-control-input" checked={showFormation === false} />
										<label className="custom-control-label" htmlFor={'NonFormation'}>Non</label>

									</div>
								</div>
								{
									showFormation ?
										<div className="block p-sm bg-light rounded mb-3">
											<div className="form-row">
												<div className="form-group">
													<label className="h6 font-weight-bolder" htmlFor="SetupFeeInput">Nombre de jours</label>
													<input type="number" className="form-control" id="SetupFeeInput" value={userInfo.daysOfTraining} onChange={(e) => setUserInfo({ ...userInfo, daysOfTraining: e.target.value })} />
												</div>
											</div>
										</div>
										:
										''
								}
							</div>
							<hr className="my-3" />
							<div className="grid grid-md-2 align-items-center my-sm">
								<div className="mr-auto my-auto">
									<h5 className={"h4 text-uppercase text-secondary font-weight-bolder my-auto"}>Actif</h5>
									{/* <p className="o-60 fs-3 mb-0">Activer ou désactiver l'utilisateur de ce partenaire</p> */}
								</div>
								<div className="flex-row ml-auto align-items-center">
									{/* <div className="form-inline mb-3"> */}
									<div className="custom-control custom-radio custom-control-inline" >
										<input required={userInfo.isEnabled === undefined ? true : false} type="radio" id={'OuiStatut'} name='Statut' onClick={() => setUserInfo({ ...userInfo, isEnabled: true })} onChange={() => { }} className="custom-control-input" checked={userInfo.isEnabled === true} />
										<label className="custom-control-label" htmlFor={'OuiStatut'}>Oui</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline mr-0" >
										<input required={userInfo.isEnabled === undefined ? true : false} type="radio" id={'NonStatut'} name='Statut' onClick={() => setUserInfo({ ...userInfo, isEnabled: false })} onChange={() => { }} className="custom-control-input" checked={userInfo.isEnabled === false} />
										<label className="custom-control-label" htmlFor={'NonStatut'}>Non</label>

									</div>
								</div>
							</div>
						</form>
					</div>
					<div className="modal-footer pt-0">
						<button type="button" className="btn btn-faded" data-dismiss="modal" onClick={(e) => resetForm()}>Fermer</button>
						{
							isLoading.includes(Loadings.CREATING_USER) || isLoading.includes(Loadings.UPDATING_USER) ?
								<button type="button" className="btn btn-info loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Enregistrer</button>
								:
								<button type="button" className="btn btn-info" onClick={
									(e) => {
										e.preventDefault();
										let internationalPhoneNumber = null;
										if(!R.isNil(userInfo.phoneNumber) && !R.isEmpty(userInfo.phoneNumber)){
											internationalPhoneNumber = parsePhoneNumber(userInfo.phoneNumber, userInfo.phoneCountry);
											if (R.isNil(internationalPhoneNumber) || !internationalPhoneNumber.isValid()) {
												document.getElementById("phoneNumberInput").setCustomValidity("Le numéro de téléphone n'est pas valide.");
											}
										}
										if (formRef.current.checkValidity()) {

											if (R.isNil(userInfo.id)) {
												dispatch(CreateUserByPartnerId({ ...userInfo, phoneNumber: R.isNil(internationalPhoneNumber) ? null : internationalPhoneNumber.number }, partnerId))
													.then(() => {
														$('.modal').modal("hide");
														resetForm();
													});
											} else {
												dispatch(UpdateUserByPartnerId({ ...userInfo, phoneNumber: R.isNil(internationalPhoneNumber) ? null : internationalPhoneNumber.number, professionalSituation: 'Employed' }, partnerId))
													.then(() => {
														$('.modal').modal("hide");
														resetForm();
													});
											}
										}
										formRef.current.classList.add('was-validated');
									}
								}>Enregistrer</button>
						}
					</div>
				</div>
			</div>
		</div>
	);
};